import { get } from 'lodash'

export default function(award) {
  return {
    paymentDate: get(award, 'participantRegistration.awardPayment.paymentDate'),
    transactionId: get(award, 'participantRegistration.awardPayment.transactionId'),
  }
}

